(() => {
  const root = document.querySelector('[data-soph-journey]');
  if (!root) return;
  const incoming = new URLSearchParams(window.location.search);
  const productPath = root.dataset.productPath;
  const allowed = /^(utm_(source|medium|campaign|content|term|id|source_platform|creative_format|marketing_tactic)|fbclid|gclid|gbraid|wbraid|tw_source|tw_adid|tw_campaign|tw_kwdid|soph_lp_test|soph_lp_arm)$/;
  root.querySelectorAll('[data-soph-journey-cta]').forEach((link) => {
    const destination = new URL(link.href, window.location.origin);
    if (destination.origin !== window.location.origin || destination.pathname !== productPath) return;
    incoming.forEach((value, key) => {
      if (allowed.test(key)) destination.searchParams.set(key, value);
    });
    link.href = destination.href;
  });
})();
